module.exports = __webpack_public_path__ + "img/icon_at_home.svg";